import { GalleryConfig } from 'rangeConfig/@types';

const aurdalGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: []
    }
  ]
};

export default aurdalGalleryConfig;
